import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MoovData, MoovInstanceData, MoovViewData } from 'src/app/moov-common/services/challenge/challenges-data';
import { ChallengesService } from 'src/app/moov-common/services/challenge/challenges.service';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { PersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.service';

import { filter } from 'lodash';
import { MatSidenav } from '@angular/material/sidenav';
import * as _ from 'lodash';
import { AbstractChallengesService } from 'src/app/moov-common/services/challenge/challenges.abstract.service';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { ActivatedRoute } from '@angular/router';
import { InternalEventsManagerService } from 'src/app/moov-common/services/internal-events-manager/internal-events-manager.service';


class counterpartMoovs{
  id: string;
  score: number;

  constructor(){}
} 
@Component({
  selector: 'app-team-active-moovs-view',
  templateUrl: './team-active-moovs-view.component.html',
  styleUrls: ['./team-active-moovs-view.component.scss']
})
export class TeamActiveMoovsViewComponent extends BaseComponent implements OnInit {
  moovsImagesRootFolder = 'assets/moovs/';

  activeMoovs : MoovInstanceData[];
  activeMoovsCount: number;
  overdueMoovsCount: number;
  isSelectedActiveMoov: boolean;
  userId: string;
  selectedMoov: MoovData;
  activeMoovDetails: MoovViewData;
  breakpoint: number;
  PC_VIEW_COLS_NUM = 4;
  MOBILE_VIEW_COLS_NUM = 1;
  @ViewChild("moovSideNav") sideNavRef: MatSidenav;
  
  constructor(private readonly challengesService: AbstractChallengesService, 
              public personalUserDataService: AbstractPersonalUserDataService, 
              private route: ActivatedRoute,
              private internalEventsService: InternalEventsManagerService) {
    super();
    this.isSelectedActiveMoov = false;
    this.activeMoovs = [];
   }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isMobileView){
      this.breakpoint = this.MOBILE_VIEW_COLS_NUM;
    }
    else{
      this.breakpoint = this.PC_VIEW_COLS_NUM;
    }
  
    this.getActiveMoovsForUser();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  getActiveMoovsForUser(): void{
    if (this.user != undefined){
      this.challengesService.getActiveMoovsForUser().subscribe(activeMoovs => {

        let userScoreMap = new Map();
        let userActiveMoovsMap = new Map<string, MoovInstanceData[]>();

        // get the maximum priority active moov for user
        for (let currActiveMoov of activeMoovs){
          if (userScoreMap.has(currActiveMoov.counterpartId)){
            if (currActiveMoov.priority > userScoreMap.get(currActiveMoov.counterpartId)!){
              userScoreMap.set(currActiveMoov.counterpartId, currActiveMoov.priority);
            }
          }
          else{
            userScoreMap.set(currActiveMoov.counterpartId, currActiveMoov.priority);
          }

          if (userActiveMoovsMap.has(currActiveMoov.counterpartId)){
              let userActiveMoovs = userActiveMoovsMap.get(currActiveMoov.counterpartId);
              userActiveMoovs = [...userActiveMoovs!, currActiveMoov];
              userActiveMoovsMap.set(currActiveMoov.counterpartId, userActiveMoovs);              
          }
          else{
            let userActiveMoovs = [currActiveMoov];
            userActiveMoovsMap.set(currActiveMoov.counterpartId, userActiveMoovs);
          }
        }

        // console.log(`counterpartSortedArray ${JSON.stringify(Array.from(userScoreMap.entries()))}`);

        let counterpartSortedArray:counterpartMoovs[] = [];
        for (let counterpartId of userScoreMap.keys()){
          let currCPScore = new counterpartMoovs;
          currCPScore.id = counterpartId;
          currCPScore.score = userScoreMap.get(counterpartId)!;
          counterpartSortedArray = [...counterpartSortedArray, currCPScore];
        }

        counterpartSortedArray = _.orderBy(counterpartSortedArray, ['score'], ['desc']);


        let totalActiveMoovs:MoovInstanceData[] = [];

        for (let currCounterpart of counterpartSortedArray){
          let specificCounterpartMoovs = userActiveMoovsMap.get(currCounterpart.id)!;
          totalActiveMoovs = [...totalActiveMoovs, ..._.orderBy(specificCounterpartMoovs, ['plannedEndDate'], ['asc'])];
        }
  
        this.activeMoovs = totalActiveMoovs;

        const overdueMoovs = filter(this.activeMoovs, {'isOverdue': true});

        if (overdueMoovs != undefined){
          this.overdueMoovsCount = overdueMoovs.length;
        }
        else{
          this.overdueMoovsCount = 0;
        }

        this.activeMoovsCount = activeMoovs.length - this.overdueMoovsCount;

        this.internalEventsService.teamActiveMoovs_dataLoaded.emit("");
      })
    }
  }

  ngAfterViewInit(): void{
    this.route.queryParams.subscribe(params => {
      // console.log(`in TV ngAfterViewInit params are ${JSON.stringify(params)}`); 
      let counterpartId = params.counterpartId;
      let activeMoovId = params.activeMoovId;

      if (counterpartId == undefined && activeMoovId == undefined){
        // console.log(`in TV onInit dbgCounterpartId is undefined`);
      }
      else {
        if (this.activeMoovs.length == 0){
          // This is not bullet proof. I know. It is good enough.
          // We know that there should be active moovs, as we are trying to open one from URL, but activeMoovs is empty, load have not finished yet
          this.internalEventsService.teamActiveMoovs_dataLoaded.subscribe(event => {
            // wait for active moovs to load before continue
            this.openActiveMoov(activeMoovId);
          });
        }
        else{
          this.openActiveMoov(activeMoovId);
        }
      }
    });
  }

  getCounterpartInitials(activeMoov: MoovInstanceData): string{
    if (activeMoov.counterpartFirstName && activeMoov.counterpartLastName){
      const counterpartInitials = activeMoov.counterpartFirstName.substring(0, 1) + activeMoov.counterpartLastName.substring(0,1);
      return counterpartInitials;
    }

    return "";
  }

  closeMoovView() {
    this.sideNavRef.close();
  }

  openActiveMoov (activeMoovId: string): void {
    const selectedActiveMoovDetails = this.activeMoovs.find (am => am.id == activeMoovId);

    if (selectedActiveMoovDetails == undefined){
      return;
    }

    if (selectedActiveMoovDetails.moovData == undefined){
      return;
    }

    this.activeMoovDetails = {activeMoovDetails:selectedActiveMoovDetails,moovDetails:selectedActiveMoovDetails.moovData, isPastMoov:false, isActiveMoov:true, counterpartId:selectedActiveMoovDetails.counterpartId};

    this.isSelectedActiveMoov = true;
    
    if (!selectedActiveMoovDetails.isMoovForSelf){
      this.analytics.activeMoovViewedEvent(this.activeMoovDetails.counterpartId!, selectedActiveMoovDetails.moovData!.issueId!, selectedActiveMoovDetails.moovData!.id, activeMoovId);
    }
    else{
      this.analytics.activeMoovViewedEvent("",selectedActiveMoovDetails.moovData!.issueId!, selectedActiveMoovDetails.moovData!.id, activeMoovId);
    }
    this.sideNavRef.open();
  }


  activeMoovEnded(activeMoovId: string) :void{
    this.sideNavRef.close();
    this.getActiveMoovsForUser();
  }

  activeMoovExtended(activeMoovId: string) :void{
    this.getActiveMoovsForUser();
  }

  activeMoovUpdated(): void{
    this.getActiveMoovsForUser();    
  }
}
